var map = {
	"./cs/translations.json": [
		"./app/locale/cs/translations.json",
		"locale.cs"
	],
	"./en/translations.json": [
		"./app/locale/en/translations.json",
		"locale.en"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./app/locale lazy recursive ^\\.\\/.*\\/translations\\.json$";
module.exports = webpackAsyncContext;